import { Editor } from "@tinymce/tinymce-react";
import { useState } from "react";

const TextEditor = (props: any) => {
  const {
    handleChange,
    value,
    isLogin,
    placeholder = "Enter HR Template Content",
  } = props;
  
  const [isEditorReady, setIsEditorReady] = useState(false);
  
  const apiKey = process.env.REACT_APP_TEXT_EDITOR_API_KEY;
  const editorPlugins = [
    "advlist",
    "autolink",
    "lists",
    "link",
    "image",
    "charmap",
    "preview",
    "anchor",
    "searchreplace",
    "visualblocks",
    "code",
    "fullscreen",
    "insertdatetime",
    "media",
    "table",
    "code",
    "help",
    "wordcount",
  ];
  const menuBar = "file edit view insert format tools table help";
  const toolBar = `undo redo | bold italic underline strikethrough |
  fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify |
  outdent indent |  numlist bullist | forecolor backcolor removeformat |
  pagebreak | charmap emoticons | fullscreen  preview save print |
  insertfile image media template link anchor codesample | ltr rtl`;

  const init = {
    height: isLogin ? 220 : 300, 
    plugins: editorPlugins,
    menubar: menuBar,
    toolbar: toolBar,
    placeholder: placeholder,
  };

  const handleEditorInit = () => {
    setIsEditorReady(true);
  };

  return (
    <div style={{ position: 'relative', minHeight: isLogin ? 220 : 300 }}>
      {!isEditorReady && (
        <div 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            zIndex: 10,
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <div 
              style={{
                border: '3px solid #e9ecef',
                borderTop: '3px solid #007bff',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 8px',
              }}
            />
            <span style={{ fontSize: '14px', color: '#6c757d' }}>
              Loading editor...
            </span>
          </div>
        </div>
      )}
      <div style={{ opacity: isEditorReady ? 1 : 0 }}>
        <Editor
          apiKey={apiKey}
          value={value}
          onEditorChange={handleChange}
          onInit={handleEditorInit}
          init={init}
        />
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default TextEditor;
